<script lang="ts">
	import { parallax } from '$lib/actions/parallax';
	import { reveal } from '$lib/actions/reveal';
	import { DotLottieSvelte } from '@lottiefiles/dotlottie-svelte';
</script>

<section
	id="platform"
	class="reveal reveal-delay-4 relative mx-auto mt-20 w-full max-w-[1600px] overflow-hidden"
	use:reveal
>
	<div class="subtle-glow absolute inset-0 -z-10"></div>
	<div use:parallax={{ strength: 0.03 }} class="w-full">
		<DotLottieSvelte
			src="/animations/Admiral - Dashboard.json"
			backgroundColor="transparent"
			speed={1}
			loop
			autoplay
		></DotLottieSvelte>
	</div>
</section>
